export default {
  navigationBarTitleText: intl.get('padPage.selectOrganization.selectAccount')
};
